import { types as actions } from '../actions';

const defaultState = {
  list: [],
  currentAction: {}
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.SET_ACTIONS:
      return {
        ...state,
        list: action.actions
      };
    case actions.ADDED_ACTION:
      let found = state.list.find(action => action.id === action.action.id);
      return {
        ...state,
        list: found ? state.list : [...state.list, action.action]
      };
    case actions.SET_CURRENT_ACTION:
      return {
        ...state,
        currentAction: action.action
      };
    case actions.EDITED_ACTION:
      return {
        ...state,
        list: state.list.map(
          item => (item.id === action.action.id ? action.action : item)
        )
      };
    case actions.REMOVE_ACTION:
      return {
        ...state,
        list: state.list.filter(item => item.id !== action.action.id)
      };
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/trigger-actions/index.js